import { render, staticRenderFns } from "./SourcesList.vue?vue&type=template&id=4e42de6e&"
import script from "./SourcesList.vue?vue&type=script&lang=js&"
export * from "./SourcesList.vue?vue&type=script&lang=js&"
import style0 from "./SourcesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports